import React, { useEffect, useState } from "react";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import DataTable from "react-data-table-component";
import {
  SecodaryBidHistoryData,
  SecondaryMarketMyBidHistoryData,
} from "../../redux/auth-reducer/auth-service";
import { Footer } from "../../Footer";
import { formatResultDate } from "../../CommonComponent/Results/formatResultDate";
import { ResultsPager } from "../../CommonComponent/Results/ResultsPager";
import { useSearchedPagedList } from "../../hooks/useSearchedPagedList";
import { bidTimeLabel } from "../../utils/helper/auctionForm";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

const columns = [
  {
    name: "#",
    selector: (row, index) => index + 1,

    width: "80px",
  },
  {
    name: "Team Name",
    selector: (row) => row?.teamName,
    sortable: true,
  },
  {
    name: "Auction Name",
    selector: (row) => row?.auctionName,
    sortable: true,
  },

  {
    name: "Bid Increment",
    selector: (row) => row?.bidIncrement,
    sortable: true,
  },
  {
    name: "Total Placed Bids",
    selector: (row) => row?.totalPlacedBids,
    sortable: true,
  },

  {
    name: "Bid Time",
    selector: (row) => row?.bidTime,
    format: (row) => bidTimeLabel(row?.bidTime),
    sortable: true,
  },
  {
    name: "Bid Amount",
    selector: (row) => row?.currentBidAmount,
    sortable: true,
  },
  {
    name: "Bidder",
    selector: (row) => row?.bidPlacedByName || "-",
    sortable: true,
  },
  {
    name: "Ownership Sell",
    selector: (row) => (row?.ownerShip ? `${row.ownerShip}%` : "-"),
    sortable: true,
  },
  // #140: one row per bid, so each shows when it was placed.
  {
    name: "Placed At",
    selector: (row) => row?.bidDateTime,
    format: (row) => (row?.bidDateTime ? formatResultDate(row.bidDateTime) : "-"),
    sortable: true,
    width: "220px",
  },
];

const columnsMyBid = [
  {
    name: "#",
    selector: (row, index) => index + 1,

    width: "80px",
  },
  {
    name: "Team Name",
    selector: (row) => row?.teamName,
    sortable: true,
  },
  {
    name: "Auction Name",
    selector: (row) => row?.auctionName,
    sortable: true,
  },

  {
    name: "Bid Increment",
    selector: (row) => row?.bidIncrement,
    sortable: true,
  },
  {
    name: "Level",
    selector: (row) => row?.auctionLevel,
    sortable: true,
  },

  {
    name: "Bid Time",
    selector: (row) => row?.bidTime,
    format: (row) => bidTimeLabel(row?.bidTime),
    sortable: true,
  },
  {
    name: "Starting Bid",
    selector: (row) => row?.startingBid,
    sortable: true,
  },

  {
    name: "Bid Amount",
    selector: (row) => row?.myBidAmount,
    sortable: true,
  },
];

/**
 * One tab's searched, server-paged table.
 *
 * #184 (reopened): the search is the server's - usp_GetAllSMBidHistory matches the auction, team
 * and bidder, usp_GetAllMySMBidModel the auction and team - and the pager counts the matches. It
 * used to filter only the rows of the page already loaded, so a bid on any other page was never
 * found.
 *
 * @param {object} props
 * @param {Function} props.fetcher The auth-service wrapper for the tab's list.
 * @param {Array} props.columns The table's columns.
 * @param {string} props.searchClassName The class of the search row, as each tab had it.
 */
const BidHistoryTab = ({ fetcher, columns, searchClassName }) => {
  const pager = useSearchedPagedList(fetcher);

  return (
    <div>
      <div className={searchClassName}>
        <input
          type="text"
          className="form-control mb-3 mt-3"
          placeholder="Search..."
          value={pager.searchText}
          onChange={(e) => pager.setSearchText(e.target.value)}
        />
        {pager.searchText && (
          <button className="btn btn-clear" onClick={pager.clearSearch}>
            <span>&times;</span> {/* This represents the close icon */}
          </button>
        )}
      </div>

      <div>
        <DataTable columns={columns} data={pager.rows} />
        <ResultsPager
          page={pager.page}
          totalPages={pager.totalPages}
          perPage={pager.perPage}
          pageSizes={pager.pageSizes}
          onPerPageChange={pager.changePerPage}
          onPrevious={pager.previousPage}
          onNext={pager.nextPage}
        />
      </div>
    </div>
  );
};

export const SecodaryBid = () => {
  const [sidebar, setSidebar] = useState(false);
  function sidebarfun() {
    setSidebar(!sidebar);
  }
  const [key, setKey] = useState(() => {
    return localStorage.getItem("activeTabBid") || "All Bids";
  });

  useEffect(() => {
    localStorage.setItem("activeTabBid", key);
  }, [key]);

  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={sidebar} />
        <div
          className={
            sidebar ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <h1 className="heading-dash">Secondary Market Bids</h1>
          <div className="group_data_table">
            <div className="group_data_table tabs-auction">
              <div className="tabs-box">
                {/* Each tab owns its list, paging and search, and loads when first opened. They
                    used to share one page number, and both lists were fetched on every page
                    change whichever tab was shown. */}
                <Tabs
                  id="auctiontabs"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}
                  className="mb-0 tab-list-item"
                  justify
                  mountOnEnter
                >
                  <Tab eventKey="All Bids" title="All Bids">
                    <BidHistoryTab
                      fetcher={SecodaryBidHistoryData}
                      columns={columns}
                      searchClassName="search-input d-flex align-items-center"
                    />
                  </Tab>

                  <Tab eventKey="My Bids" title="My Bids">
                    <BidHistoryTab
                      fetcher={SecondaryMarketMyBidHistoryData}
                      columns={columnsMyBid}
                      searchClassName="search-input filter auction-filter palyer"
                    />
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-content">
          <Footer />
        </div>
      </div>
    </>
  );
};
